import { create } from 'zustand'

/**
 * The help quick view (CLA-1838): one article in a side panel over the page
 * you are on, opened from ⌘K's "Read more". Closing it leaves you where you
 * were; "Open in Help" goes to the full article page.
 */
interface HelpPanelState {
  slug: string | null
  open: (slug: string) => void
  close: () => void
}

export const useHelpPanelStore = create<HelpPanelState>((set) => ({
  slug: null,
  open: (slug) => set({ slug }),
  close: () => set({ slug: null }),
}))
